import { createFileRoute } from '@tanstack/react-router';
import { JourneysManualSegmentTabHandoff } from '@/pages/workspaces/segments/[segmentId]/overview/routing';

/**
 * The `journeys` URL the segment tab bar links to for People. It reads the segment and
 * forwards a manual one to the tab's own URL, leaving any other
 * with the embedded app.
 */
function JourneysSegmentPeopleRoute() {
  const { segmentId } = Route.useParams();

  return <JourneysManualSegmentTabHandoff segmentId={segmentId} tab="people" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/people')({
  component: JourneysSegmentPeopleRoute,
});
